export const SPECIAL_FIELD_PREFIX = '__ifc__' as const;
export const SPECIAL_SYS_PREFIX = '__sys_' as const;

export const FIELD_NAMES = {
    DELIVERY_METHOD: 'deliveryMethod',
    PAYMENT_METHOD: 'paymentSourceFromMethod',
    FROM_ACCOUNT: `${SPECIAL_FIELD_PREFIX}from_account`,
    SOURCE_CARD_EXP_DATE: 'source_card_exp_date',
    CARD_EXP_DATE: 'exp_date',
    SOURCE_CARD_CVV: 'source_card_cvv',
    FROM_CNR_ID: `${SPECIAL_SYS_PREFIX}pay_from_cnr_id`,
    TO_CNR_ID: `${SPECIAL_SYS_PREFIX}pay_to_cnr_id`,
    SOURCE: `${SPECIAL_FIELD_PREFIX}source`,
    ACCOUNT: 'account',
    ACCOUNT_TO: `${SPECIAL_FIELD_PREFIX}to_account`,
    AMOUNT_TO: `${SPECIAL_FIELD_PREFIX}to_amount`,
    AMOUNT_TO_CCY: `${SPECIAL_FIELD_PREFIX}to_amount_ccy`,
    AMOUNT_TO_ISO: `${SPECIAL_FIELD_PREFIX}to_amount_iso`,
    AMOUNT_FROM: `${SPECIAL_FIELD_PREFIX}from_amount`,
    AMOUNT_FROM_ISO: `${SPECIAL_FIELD_PREFIX}from_amount_iso`,
    AMOUNT_FROM_CCY: `${SPECIAL_FIELD_PREFIX}from_amount_ccy`,
    TO_PRV_ID: 'toPrvId',
    CVV: 'source_card_cvv',
    CARD_CVV: 'cvv',
    FROM_PRV_ID: 'fromPrvId',
    SOURCE_CODE_FROM: 'sourceCodeFrom',
    SOURCE_CODE_TO: 'sourceCodeTo',
    PROMO_CODE_FIELD: 'pay_promo_code',
    PHONE: 'phone',
    BILL_ISSUER_COMMENT: 'billIssuerComments',
    ID: 'id',
    FROM_COUNTRY_NAME: 'fromCountryName',
    AMOUNT: 'amount',
    TO_BANK_CODE: 'to_bank_code',
    POST_CODE: 'post_code',
    TO_BIK: 'to_bik',
    TO_ACCOUNT_TYPE: 'to_account_type',
    PAN: 'pan',
    TO_PHONE_NUMBER: 'to_phone_number',
    TO_TRANSFER_PURPOSE: 'to_transfer_purpose',
    TRANSFER_PURPOSE: 'transfer_purpose',
    COMMENT: 'comment',
    REPEAT_PAYMENT_ID: 'repeatPaymentId',
    CODE: 'code',
    PHONE_NUMBER: 'phone_number',
    PHONE_PREFIX: 'phone_prefix',
    PHONE_COUNTRY: 'phone_country',
    PARTNER_CODE: 'partner_code',
    TO_ISSUER_CODE: 'to_issuer_code',
    BANK_ACCOUNTCODE: 'to_bankcode',
    BANK_ACCOUNT_CODE: 'to_bank_code',
    BANK_ACCOUNT_ID: 'to_bank_id',
    SWIFT_CODE: 'to_swift_code',
    TO_RECIPIENT: 'to_recipient',
    TO_RECIPIENT_OTHER: 'to_recipient_other',
    TO_RECIPIENT_BIZ: 'to_recipient_biz',
    TO_RECIPIENT_SELF: 'to_recipient_self',
    TO_RECIPIENT_CATEGORY_TYPE: 'to_recipient_category_type',
    TO_BIC: 'to_bic',
    BIK_TYPE: 'to_bik',
    TO_SORT_CODE: 'to_sort_code',
    TO_COMMENT: 'to_comment',
    TO_IBAN: 'to_iban',
    IS_IBAN: 'is_iban',
    PLACEHOLDER: 'placeholder',
    ERROR_MESSAGE: 'errorMessage',
    TYPE: 'type',
    START_DATE: 'start_date',
    END_DATE: 'end_date',
    START_DATE_CAMELCASE: 'startDate',
    END_DATE_CAMELCASE: 'endDate',
    SSN: 'ssn',
    ITIN: 'itin',
    FIRST_PIN_FIELD: 'first_pin_field',
    SECOND_PIN_FIELD: 'second_pin_field',
    THIRD_PIN_FIELD: 'third_pin_field',
    FOURTH_PIN_FIELD: 'fourth_pin_field',
    ADDRESS: 'address',
    ADDRESS_2: 'address2',
    CITY: 'city',
    RESIDENT_COUNTRY: 'resident_country',
    NAME: 'name',
    NAME_F: 'name_f',
    TO_NAME: 'to_name',
    TO_NAME_F: 'to_name_f',
    BIRTHDAY: 'birthday',
    EMAIL: 'email',
    OCCUPATION: 'occupation',
    SEX: 'sex',
    PURPOSE_OF_ACCOUNT: 'purpose_of_account',
    SOURCE_OF_INCOME: 'source_of_income',
    INCOME_TYPE: 'income_type',
    VERIFICATION_AMOUNT: 'verificationAmount',
    MARKETING_OPT_IN: 'marketing_opt_in',
} as const;

export type FieldNameKey = keyof typeof FIELD_NAMES;
export type FieldNameValue = (typeof FIELD_NAMES)[FieldNameKey];

const {
    DELIVERY_METHOD,
    PAYMENT_METHOD,
    FROM_ACCOUNT,
    SOURCE_CARD_EXP_DATE,
    CARD_EXP_DATE,
    SOURCE_CARD_CVV,
    FROM_CNR_ID,
    TO_CNR_ID,
    SOURCE,
    ACCOUNT,
    ACCOUNT_TO,
    AMOUNT_TO,
    AMOUNT_TO_CCY,
    AMOUNT_TO_ISO,
    AMOUNT_FROM,
    AMOUNT_FROM_ISO,
    AMOUNT_FROM_CCY,
    TO_PRV_ID,
    CVV,
    CARD_CVV,
    FROM_PRV_ID,
    SOURCE_CODE_FROM,
    SOURCE_CODE_TO,
    PROMO_CODE_FIELD,
    PHONE,
    BILL_ISSUER_COMMENT,
    ID,
    FROM_COUNTRY_NAME,
    AMOUNT,
    TO_BANK_CODE,
    POST_CODE,
    TO_BIK,
    TO_ACCOUNT_TYPE,
    PAN,
    TO_PHONE_NUMBER,
    TO_TRANSFER_PURPOSE,
    TRANSFER_PURPOSE,
    COMMENT,
    REPEAT_PAYMENT_ID,
    CODE,
    PHONE_NUMBER,
    PHONE_PREFIX,
    PHONE_COUNTRY,
    PARTNER_CODE,
    TO_ISSUER_CODE,
    BANK_ACCOUNTCODE,
    BANK_ACCOUNT_CODE,
    BANK_ACCOUNT_ID,
    SWIFT_CODE,
    TO_RECIPIENT,
    TO_RECIPIENT_OTHER,
    TO_RECIPIENT_BIZ,
    TO_RECIPIENT_SELF,
    TO_RECIPIENT_CATEGORY_TYPE,
    TO_BIC,
    BIK_TYPE,
    TO_SORT_CODE,
    TO_COMMENT,
    TO_IBAN,
    IS_IBAN,
    PLACEHOLDER,
    ERROR_MESSAGE,
    TYPE,
    START_DATE,
    END_DATE,
    START_DATE_CAMELCASE,
    END_DATE_CAMELCASE,
    SSN,
    ITIN,
    FIRST_PIN_FIELD,
    SECOND_PIN_FIELD,
    THIRD_PIN_FIELD,
    FOURTH_PIN_FIELD,
    ADDRESS,
    ADDRESS_2,
    CITY,
    RESIDENT_COUNTRY,
    NAME,
    NAME_F,
    TO_NAME,
    TO_NAME_F,
    BIRTHDAY,
    EMAIL,
    OCCUPATION,
    SEX,
    PURPOSE_OF_ACCOUNT,
    SOURCE_OF_INCOME,
    INCOME_TYPE,
    VERIFICATION_AMOUNT,
    MARKETING_OPT_IN,
} = FIELD_NAMES;

export {
    DELIVERY_METHOD,
    PAYMENT_METHOD,
    FROM_ACCOUNT,
    SOURCE_CARD_EXP_DATE,
    CARD_EXP_DATE,
    SOURCE_CARD_CVV,
    FROM_CNR_ID,
    TO_CNR_ID,
    SOURCE,
    ACCOUNT,
    ACCOUNT_TO,
    AMOUNT_TO,
    AMOUNT_TO_CCY,
    AMOUNT_TO_ISO,
    AMOUNT_FROM,
    AMOUNT_FROM_ISO,
    AMOUNT_FROM_CCY,
    TO_PRV_ID,
    CVV,
    CARD_CVV,
    FROM_PRV_ID,
    SOURCE_CODE_FROM,
    SOURCE_CODE_TO,
    PROMO_CODE_FIELD,
    PHONE,
    BILL_ISSUER_COMMENT,
    ID,
    FROM_COUNTRY_NAME,
    AMOUNT,
    TO_BANK_CODE,
    POST_CODE,
    TO_BIK,
    TO_ACCOUNT_TYPE,
    PAN,
    TO_PHONE_NUMBER,
    TO_TRANSFER_PURPOSE,
    TRANSFER_PURPOSE,
    COMMENT,
    REPEAT_PAYMENT_ID,
    CODE,
    PHONE_NUMBER,
    PHONE_PREFIX,
    PHONE_COUNTRY,
    PARTNER_CODE,
    TO_ISSUER_CODE,
    BANK_ACCOUNTCODE,
    BANK_ACCOUNT_CODE,
    BANK_ACCOUNT_ID,
    SWIFT_CODE,
    TO_RECIPIENT,
    TO_RECIPIENT_OTHER,
    TO_RECIPIENT_BIZ,
    TO_RECIPIENT_SELF,
    TO_RECIPIENT_CATEGORY_TYPE,
    TO_BIC,
    BIK_TYPE,
    TO_SORT_CODE,
    TO_COMMENT,
    TO_IBAN,
    IS_IBAN,
    PLACEHOLDER,
    ERROR_MESSAGE,
    TYPE,
    START_DATE,
    END_DATE,
    START_DATE_CAMELCASE,
    END_DATE_CAMELCASE,
    SSN,
    ITIN,
    FIRST_PIN_FIELD,
    SECOND_PIN_FIELD,
    THIRD_PIN_FIELD,
    FOURTH_PIN_FIELD,
    ADDRESS,
    ADDRESS_2,
    CITY,
    RESIDENT_COUNTRY,
    NAME,
    NAME_F,
    TO_NAME,
    TO_NAME_F,
    BIRTHDAY,
    EMAIL,
    OCCUPATION,
    SEX,
    PURPOSE_OF_ACCOUNT,
    SOURCE_OF_INCOME,
    INCOME_TYPE,
    VERIFICATION_AMOUNT,
    MARKETING_OPT_IN,
};
